module.exports = __webpack_public_path__ + "img/orange.0de24fda.svg";